import { Link } from "react-router-dom";
import "../App.scss";

export const NotFoundPage = () => (
  <div id="wrapper" className="center fade-in">
    <h1 style={{ fontSize: "4rem", color: "#556b2f" }}>404</h1>
    <p style={{ marginBottom: "2rem" }}>Page not found</p>
    <Link
      to="/"
      style={{
        color: "#556b2f",
        textDecoration: "none",
        fontWeight: 600,
      }}
    >
      ← Back home
    </Link>
  </div>
);
